import React, { useState } from 'react';
import styled from 'styled-components';

const MeetTeam = () => {
  const [isMemOne, setIsMemberOne] = useState(true);
  const [isMemTwo, setIsMemberTwo] = useState(false);
  const [isMemThree, setIsMemberThree] = useState(false);
  const [isMemFour, setIsMemberFour] = useState(false);
  const [isMemFive, setIsMemberFive] = useState(false);
  return (
    <>
      <HeadBox>
        <span>|| Our Team</span>
        <h1>Meet The Team</h1>
      </HeadBox>
      <MeetTeamWrapper id="our-team">
        <SidePanel>
          <div className="head">
            <h2>Our Team | Leadership</h2>
          </div>
          <div className="route">
            <div
              className="route-box"
              onClick={() => {
                setIsMemberOne(true);
                setIsMemberTwo(false);
                setIsMemberThree(false);
                setIsMemberFour(false);
                setIsMemberFive(false);
              }}>
              <p>Kwarteng Joseph</p>
            </div>
            <div
              className="route-box"
              onClick={() => {
                setIsMemberTwo(true);
                setIsMemberOne(false);
                setIsMemberThree(false);
                setIsMemberFour(false);
                setIsMemberFive(false);
              }}>
              <p>Kwarteng Joseph</p>
            </div>
            <div
              className="route-box"
              onClick={() => {
                setIsMemberThree(true);
                setIsMemberOne(false);
                setIsMemberTwo(false);
                setIsMemberFour(false);
                setIsMemberFive(false);
              }}>
              <p>Kwarteng Joseph</p>
            </div>
            <div
              className="route-box"
              onClick={() => {
                setIsMemberFour(true);
                setIsMemberOne(false);
                setIsMemberTwo(false);
                setIsMemberThree(false);
                setIsMemberFive(false);
              }}>
              <p>Kwarteng Joseph</p>
            </div>
            <div
              className="route-box"
              onClick={() => {
                setIsMemberFive(true);
                setIsMemberOne(false);
                setIsMemberTwo(false);
                setIsMemberThree(false);
                setIsMemberFour(false);
              }}>
              <p>Kwarteng Joseph</p>
            </div>
          </div>
        </SidePanel>
        <ContentBox>
          {isMemOne && <MemberOne></MemberOne>}
          {isMemTwo && <MemberTwo></MemberTwo>}
          {isMemThree && <MemberThree></MemberThree>}
          {isMemFour && <MemberFour></MemberFour>}
          {isMemFive && <MemberFive></MemberFive>}
        </ContentBox>
      </MeetTeamWrapper>
    </>
  );
};

const HeadBox = styled.div`
  width: 60%;
  margin: 0 auto;
  display: flex;
  align-items: center;
  flex-direction: column;
  gap: 1.5rem;

  span {
    color: var(--bg-color);
    font-weight: 700;
  }

  h1 {
    font-size: 2.3rem;
    font-weight: 700;
  }

  @media screen and (max-width: 430px) {
    width: 100%;
  }
`;

const MeetTeamWrapper = styled.section`
  padding: 50px 20px;
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: space-between;
  @media screen and (max-width: 768px) {
    flex-direction: column;
  }
  @media screen and (max-width: 430px) {
    flex-direction: column;
  }
`;
const SidePanel = styled.article`
  display: flex;
  width: 25rem;
  height: 90vh;
  background: #fff;
  position: relative;
  @media screen and (max-width: 768px) {
    display: none;
  }
  @media screen and (max-width: 430px) {
    display: none;
  }

  .head {
    background: var(--main-color);
    box-shadow: 0 0.2rem 1rem var(--bga-color);
    height: max-content;
    width: 100%;
    padding: 10px;

    h2 {
      font-size: 1.06rem;
      font-weight: 700;
      color: var(--bg-color);
    }
  }

  .route {
    width: 100%;
    height: calc(90vh - 35vh);
    background: var(--main-color);
    position: absolute;
    padding: 0 10px;
    top: 2.8rem;
    overflow-y: scroll;
    ::-webkit-scrollbar {
      display: none;
    }

    .route-box {
      background: #fff;
      box-shadow: 0 0.1rem 1rem var(--bga-color);
      cursor: pointer;
      color: var(--text-color);
      font-weight: 600;
      padding: 19px;
      margin: 8px 0;
      text-align: center;
      transition: transform 200ms ease-in-out;

      &:active {
        transform: scale(0.98);
      }
    }
  }
`;

const ContentBox = styled.article`
  display: flex;
  flex-direction: column;
  background: #fff;
  border: 1px solid var(--main-color);
  width: calc(100% - 25rem);
  height: 90vh;
  overflow-y: scroll;
  ::-webkit-scrollbar {
    display: none;
  }

  .mem-con {
    min-height: 100vh;
    background: #ffff;
    .mem-abt {
      .basic {
        padding: 10px;
        display: flex;
        align-items: flex-start;
        justify-content: space-between;
        .memImg {
          width: 30%;
          img {
            width: 100%;
            border: 2px solid var(--main-color);
            border-width: 10px;
            border-radius: 0.2rem;
          }
        }
        .meta-info {
          padding-right: 10px;
          h1 {
            color: var(--bg-color);
            font-size: 1.9rem;
          }
          h3 {
            padding: 10px 0;
            span {
              color: var(--bg-color);
              padding-left: 10px;
            }
          }

          .social {
            small {
              font-weight: 700;
            }
            span {
              cursor: pointer;
              display: flex;
              align-items: center;
              gap: 10px;
              padding: 9px 0;
              font-size: 20px;
              font-weight: 600;
              .m-ico {
                color: var(--ico-color);
              }
              p {
                color: var(--bg-color);
              }
            }
          }
        }
      }
      .mem-bio {
        padding: 10px;
        span {
          color: var(--bg-color);
          font-weight: 700;
        }
        p {
          color: var(--text-color);
          max-width: 850px;
          font-size: 1.08rem;
          font-weight: 600;
          line-height: 1.7;
          padding: 10px 0;
        }
      }
    }
  }

  @media screen and (max-width: 768px) {
    width: 100%;
    .mem-con {
      min-height: 80vh;
      .mem-abt {
        .basic {
          flex-direction: row;
          .memImg {
            width: 50%;
            img {
              width: 100%;
            }
          }
          .meta-info {
            h1 {
              font-size: 1.7rem;
            }
          }
        }
        .mem-bio {
          p {
            font-size: 18px;
            font-weight: 600;
            padding: 5px 0;
            line-height: 1.7;
          }
        }
      }
    }
  }

  @media screen and (max-width: 430px) {
    width: 100%;
    .mem-con {
      .mem-abt {
        .basic {
          flex-direction: column;
          .memImg {
            width: 50%;
            img {
              width: 100%;
            }
          }
          .meta-info {
            h1 {
              font-size: 1.7rem;
            }
          }
        }
        .mem-bio {
          p {
            font-size: 15px;
            font-weight: 600;
            padding: 5px 0;
          }
        }
      }
    }
  }
`;

const MemberOne = styled.div`
 height: 100%;
 background: red;
`;
const MemberTwo = styled.div`
 height: 100%;
 background: yellow;
`;

const MemberThree = styled.div`
 height: 100%;
 background: green;
`;

const MemberFour = styled.div`
 height: 100%;
 background: blue;
`;

const MemberFive = styled.div`
 height: 100%;
 background: black;
`;

export default MeetTeam;
